import { useCallback } from "react"
import { Outlet, useNavigate, useParams } from "react-router"
import { useGetCustomer } from "@/domains/customers/hooks/useGetCustomer"
import { useGetModules } from "@/domains/customers/hooks/useGetModules"
import { useGetRelatedCustomers } from "@/domains/visualization/hooks/useGetRelatedCustomers"
import { ErrorComponent } from "@/shared/components/ErrorComponent/ErrorComponent"
import { Loading } from "@/shared/components/Loading/Loading"
import { CustomerNavigation } from "../CustomerNavigation/CustomerNavigation"
import { CustomerPageHeading } from "../CustomerPageHeading/CustomerPageHeading"
import styles from "./CustomerLayout.module.css"

export function CustomerLayout() {
  const params = useParams()
  const navigate = useNavigate()

  const onBack = useCallback(() => {
    navigate(-1)
  }, [navigate])

  const customerId = params.customerId
  const query = useGetCustomer(customerId || "", !!customerId)

  // Fetch modules and related customers already here to avoid having to wait for the customer to load
  useGetModules(customerId)
  useGetRelatedCustomers(customerId)

  if (query.isLoading) {
    return (
      <div>
        <CustomerPageHeading onBack={onBack} />
        <Loading text="Loading customer..." />
      </div>
    )
  }

  if (query.isError || !query.data) {
    return (
      <div>
        <CustomerPageHeading header="" onBack={onBack} />
        <ErrorComponent error={query.error} onRetry={() => void query.refetch()} />
      </div>
    )
  }

  const customer = query.data.data

  return (
    <>
      <CustomerPageHeading header={customer.name} onBack={onBack} />
      <div className={styles.container}>
        <aside className={styles.aside}>
          <CustomerNavigation />
        </aside>
        <article className={styles.article}>
          <Outlet context={{ customer }} />
        </article>
      </div>
    </>
  )
}
